import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/api";
import AppLayout from "./components/layout/AppLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import OnboardPersonnel from "./pages/OnboardPersonnel";
import TimesheetPortal from "./pages/TimesheetPortal";
import SignAgreement from "./pages/SignAgreement";
import AvailabilityPortal from "./pages/AvailabilityPortal";
import BrandPreview from "./pages/BrandPreview";
import Roster from "./pages/Roster";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Pipeline from "./pages/Pipeline";
import Pricing from "./pages/Pricing";
import Talent from "./pages/Talent";
import FieldTechs from "./pages/FieldTechs";
import Catalog from "./pages/Catalog";
import Insights from "./pages/Insights";
import Personnel from "./pages/Personnel";
import Schedule from "./pages/Schedule";
import Clients from "./pages/Clients";
import Intake from "./pages/Intake";
import Proposals from "./pages/Proposals";
import Leave from "./pages/Leave";
import Timesheets from "./pages/Timesheets";
import Milestones from "./pages/Milestones";
import Timeline from "./pages/Timeline";
import TeamAccess from "./pages/TeamAccess";
import TalentMap from "./pages/TalentMap";
import SiteAccess from "./pages/SiteAccess";
import Leads from "./pages/Leads";
import SignSow from "./pages/SignSow";
import Backlog from "./pages/Backlog";

// Helper — reduces route boilerplate. Path is passed to ProtectedRoute so RBAC lookup is deterministic.
const Guarded = (path, Component) => (
  <ProtectedRoute path={path}>
    <AppLayout><Component /></AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/intake/:token" element={<Intake />} />
            <Route path="/onboard/personnel/:token" element={<OnboardPersonnel />} />
            <Route path="/portal/timesheet/:token" element={<TimesheetPortal />} />
            <Route path="/agreement/:token" element={<SignAgreement />} />
            <Route path="/portal/availability/:token" element={<AvailabilityPortal />} />
            <Route path="/brand-preview" element={<BrandPreview />} />
            <Route path="/sign/:token" element={<SignSow />} />

            {/* Role-guarded */}
            <Route path="/" element={Guarded("/", Dashboard)} />
            <Route path="/pipeline" element={Guarded("/pipeline", Pipeline)} />
            <Route path="/schedule" element={Guarded("/schedule", Schedule)} />
            <Route path="/pricing" element={Guarded("/pricing", Pricing)} />
            <Route path="/catalog" element={Guarded("/catalog", Catalog)} />
            <Route path="/insights" element={Guarded("/insights", Insights)} />
            <Route path="/clients" element={Guarded("/clients", Clients)} />
            <Route path="/leads" element={Guarded("/leads", Leads)} />
            <Route path="/backlog" element={Guarded("/backlog", Backlog)} />
            <Route path="/proposals" element={Guarded("/proposals", Proposals)} />
            <Route path="/timesheets" element={Guarded("/timesheets", Timesheets)} />
            <Route path="/milestones" element={Guarded("/milestones", Milestones)} />
            <Route path="/timeline" element={Guarded("/timeline", Timeline)} />
            <Route path="/team" element={Guarded("/team", TeamAccess)} />
            <Route path="/talent-map" element={Guarded("/talent-map", TalentMap)} />
            <Route path="/roster" element={Guarded("/roster", Roster)} />
            <Route path="/talent" element={Guarded("/talent", Talent)} />
            <Route path="/field-techs" element={Guarded("/field-techs", FieldTechs)} />
            <Route path="/personnel" element={Guarded("/personnel", Personnel)} />
            <Route path="/site-access" element={Guarded("/site-access", SiteAccess)} />
            <Route path="/leave" element={Guarded("/leave", Leave)} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
